// index.js or main file
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import DiwaliIndex from './pages/diwaliEscapeRoom/DiwaliIndex';
import DiwaliMain from './pages/diwaliEscapeRoom/DiwaliMain';
import DiwaliGame from './pages/diwaliEscapeRoom/DiwaliGame';
import DiwaliPoker from './pages/diwaliEscapeRoom/DiwaliPoker';
import DiwaliThankyou from './pages/diwaliEscapeRoom/DiwaliThankyou';

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route index element={<DiwaliIndex />} />
        <Route path="/diwali" element={<DiwaliIndex />} />
        <Route path="/diwali/main" element={<DiwaliMain />} />
        <Route path="/diwali/game" element={<DiwaliGame />} />
        <Route path="/diwali/game/poker" element={<DiwaliPoker />} />
        <Route path="/diwali/thankyou" element={<DiwaliThankyou />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
